import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTheme } from '../theme';

import { AuthLogin, AuthResetPassword } from '../components/auth';

const Stack = createStackNavigator();

const UnauthenticatedAppStack = () => {
	const { theme } = useTheme();

	return (
		<Stack.Navigator
			screenOptions={{
				headerShown: false,
				cardStyle: {
					backgroundColor: theme.mainBg1,
				},
			}}
		>
			<Stack.Screen
				name="Login"
				component={AuthLogin}
			/>
			<Stack.Screen
				name="ResetPassword"
				component={AuthResetPassword}
			/>
		</Stack.Navigator>
	);
};

export default UnauthenticatedAppStack;
